track = require 'debug/track'

initialPageLoad = true
initialVisibilityHidden = document.visibilityState == 'hidden'
initialUrl = window.location.href

module.exports = (eventName, duration) ->
  initialPageLoad = if (initialPageLoad && initialUrl == window.location.href) then true else false
  eventLabel = if initialPageLoad then 'initialPageLoad' else 'routeChange'
  hiddenLabel = if (initialPageLoad && initialVisibilityHidden) ||
            document.visibilityState == 'hidden' then 'hidden' else 'visible'

  fetchStartDuration = Date.now() - window.performance.timing.fetchStart
  totalDuration = if initialPageLoad then fetchStartDuration else duration

  track('apdex', eventName, eventLabel, hiddenLabel, totalDuration)
  if initialPageLoad
    track('apdex', eventName, 'timeSpentBeforeMeasure', hiddenLabel, fetchStartDuration - duration)

  initialPageLoad = false




// WEBPACK FOOTER //
// ./app/scripts/debug/apdex-tracker.coffee